import styled, { keyframes, css } from "styled-components";

const spinAnimation = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

export const LastUpdatedContainer = styled.div<{ spin?: boolean }>`
  display: flex;
  gap: 8px;
  color: var(--section-granite-color, var(--granite));
  align-items: center;
  justify-content: flex-end;
  position: relative;
  margin-bottom: 19px;
  height: 24px;

  svg {
    ${({ spin }) =>
      spin
        ? css`
            animation: ${spinAnimation} 1.5s linear infinite;
          `
        : undefined};
  }
`;

export const LastUpdatedText = styled.span`
  font-size: 13px;
  font-weight: 600;
  color: var(--section-granite-color, var(--granite));
`;
